import { render, staticRenderFns } from "./timer-display.vue?vue&type=template&id=36b6488a&scoped=true&"
import script from "./timer-display.vue?vue&type=script&lang=js&"
export * from "./timer-display.vue?vue&type=script&lang=js&"
import style0 from "./timer-display.vue?vue&type=style&index=0&id=36b6488a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b6488a",
  null
  
)

export default component.exports